import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux';
import FusePageCarded from "../../../@fuse/components/FusePageLayouts/FusePageCarded";
import classNames from 'classnames';
import {
  Tabs,
  Tab, Icon, Typography, Button
} from '@material-ui/core';
import WatchList from '../dashboard/components/WatchList';
import OrdersChart from './components/OrdersChart';
import OHLC from './components/OHLC';
import OrdersList from '../dashboard/components/OrderList';
import { companySelector } from '../../../store/reducers/company.reducer';
import Util from '../../../yeffect/utils';
import {API, CRM} from "../../../config";
import Dashboard from "../dashboard/Dashboard";

import DataTile from "./components/DataTile";
import {fetchCompanyHistory, setCompaniesInfo} from "../../../store/actions";

const market_depth = API.service('market-depth');
const completed_trades = API.service('completed-trades');
const company = API.service('company');

const Span = styled.span`
	width: ${props => props.width || 100}%;
	text-align: center;
	color: black;
	padding-left: 10px;
	padding-right: 10px;
	font-family: Myriad;
	font-size: 12px;

	&.bold {
		font-weight: bold;
		font-family: Myriad;
		font-size: 12px;
	}
	&.smalleft {
		text-align: left;
		font-family: Myriad;
		fontSize: 10px;
	}
	&.smallright {
		text-align: right;
		font-family: Myriad;
		fontSize: 10px;
	}

	&.left {
		text-align: left;
		font-family: Myriad;
		font-size: 12px;
	}

	&.right {
		text-align: right;
		font-family: Myriad;
		font-size: 12px;
	}
`;

const styles = theme => ({
  layoutRoot: {
    display: 'flex',
    flex: 1,
    //height: '100vh',
    overflow: 'hidden'
  },
  depth:{

  },
  container: {
    flex: '1 0 auto',
  },
  content: {
    padding: 10,
  },
  flexBox: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',

    '&.center': {
      alignItems: 'center',
    }
  },
  margin20: {
    margin: 20,
  },
  marginX5: {
    marginTop: 5,
    marginBottom: 5,
  },
  tableHeader: {
    height: 35,

    '@media (max-width: 1680px)': {
      height: 25,
    },
  },
  tableRow: {
    //background: '#2e323a',
    marginTop: 3,
    height: 25,

    '@media (max-width: 1680px)': {
      height: 25,
    },
  },
  whiteScrollHandler: {
    overflowY: 'auto',
  },
  textBox: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing.unit,
    padding:10,
    backgroundColor:'#814392'
  },
  dataContainer: {
    marginTop: 10,
  },
  TileHead:{
    fontSize:16,
    textAlign:'center',
    display:'block',
    textTransform:'uppercase'
  },
  TileData:{
    fontSize:34,
    textAlign:'center',
    display:'block'
  }
});

/*var DataGrouper = (function() {
  var has = function(obj, target) {
      return _.some(obj, function(value) {
          return _.isEqual(value, target);
      });
  };

  var keys = function(data, names) {
      return _.reduce(data, function(memo, item) {
          var key = _.pick(item, names);
          if (!has(memo, key)) {
              memo.push(key);
          }
          return memo;
      }, []);
  };

  var group = function(data, names) {
      var stems = keys(data, names);
      return _.map(stems, function(stem) {
          return {
              key: stem,
              vals:_.map(_.filter(data, stem), function(item) {
                  return _.omit(item, names);
              })
          };
      });
  };

  group.register = function(name, converter) {
      return group[name] = function(data, names) {
          return _.map(group(data, names), converter);
      };
  };

  return group;
}());*/

class CompanyView extends Component {
  state = {
    tab3: 0,
    offers: [],
    bids: [],
    completed_trades: [],
    chart_data:[],
    cr:{},
    crmLink:CRM,
    total_commission: 0,
    total_value: 0,
    total_executions: 0,
    total_orders: 0,
    updating:false,
    consOrders: {buy:[], sell:[]},
    currency:false,
    widget_options: {
      chartType : 'bar',
      labels    : ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      options   : {
        spanGaps           : false,
        legend             : {
          display: false
        },
        maintainAspectRatio: false,
        layout             : {
          padding: {
            top   : 10,
            left  : 0,
            right : 0,
            bottom: 0
          }
        },
        scales             : {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              display: false,
            }
          ]
        }
      }
    }
  };

  getCompanyRecord = (account) => {
    const app = this;
    company.find({query:{_company_account:account.account_number}}).then((cr)=>{
      if(cr.total > 0){
        app.setState({
          cr:cr.data[0],
          crmLink:CRM + cr.data[0]._crm_link
        })
      }
    })
  }

  async getMarketDepth(account) {
    if(this.state.updating === false) {
      this.setState({updating: true});
      market_depth.get( account.account_number).then(to => {

        var toBuy = 0;
        var toBuyVolume = 0;
        var toSell = 0;
        var toSellVolume = 0;
        var toBuyCount = 0;
        var toSellCount = 0;

        to.depth['buy'].forEach(function (row) {
          toBuy = toBuy + row._price;
          toBuyVolume = toBuyVolume + parseInt(row.qty,10);
          toBuyCount = toBuyCount + parseInt(row.count,10);
        });

        to.depth['sell'].forEach(function (row) {
          toSell = toSell + row._price;
          toSellVolume = toSellVolume + parseInt(row.qty,10);
          toSellCount = toSellCount+ parseInt(row.count,10);
        });

        this.setState({
          totBuy: toBuy,
          totBuyVolume: toBuyVolume,
          buyCount: to.depth['buy'].length,
          totSell: toSell,
          totSellVolume: toSellVolume,
          totSellCount: toSellCount,
          totBuyCount: toBuyCount,
          sellCount: to.depth['sell'].length,
          total_orders: toSellCount + toBuyCount,
        });

        if (to.depth['sell'].length > 0) {
          this.setState({offer: to.depth['sell'][0]._price})
        }

        if (to.depth['buy'].length > 0) {
          this.setState({bid: to.depth['buy'][0]._price})
        }

        this.setState({ consOrders:to.depth, updating: false});

      });

    }
  }

  getCompletedTrades = (account) => {
    let tv = 0,
        te = 0,
        tc = 0;
    completed_trades.find({query:{_company_account:account.account_number,type:'30Day'}}).then(ct => {
      ct.forEach((d,k)=>{
        tc = tc + parseFloat(d.buy_commission) + parseFloat(d.sell_commission);
        tv = tv + parseFloat(d.value);
        te = te + parseInt(d.executions,10);
      })

      this.setState({
        chart_data: ct.slice(0,5),
        total_commission: tc,
        total_value: tv,
        total_executions: te,
      })

      completed_trades.find({query:{_company_account:account.account_number}}).then(ct => {
        this.setState({
          completed_trades: ct.data,
        })
      })

      /*const { tc, tv } = ct.data.reduce(({tc, tv}, d) => ({
        tc: tc + parseFloat(d.buy_commission) + parseFloat(d.sell_commission),
        tv: tv + parseFloat(d.value),
      }), {tc: 0, tv: 0});
      let todayTrades = ct.data.filter(t => {
        var dateA = new Date(t._ts_executed), dateB = new Date();
        dateB.setHours(0,0,0,0);
        return (dateA - dateB) >= 0;
      })
      this.setState({
        completed_trades: ct.data,
        total_commission: tc,
        total_value: tv,
        total_executions: ct.total,
      });*/
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedCompany) {
      const { selectedCompany } = nextProps;
      if (this.state.select !== selectedCompany.id) {
        this.setState({ tab2: 0 });
        this.setState({ select: selectedCompany.account_number });
        this.setState({ marketOrders: [[], []] })
        //this.setState({ consOrders: [[], []] })
        this.getMarketDepth(selectedCompany);
        this.getCompanyRecord(selectedCompany);
        this.getCompletedTrades(selectedCompany);
        this.setState({
          currency:Util.getCurrency(selectedCompany.currency)
        })
      }
    }
  }

  closeCompany = () => {
    this.props.selectCompany(false);
  }

  widgetOptions = () => {
    let options = this.state.widget_options;
    options.labels = this.chartLabels();
    return options;
  }

  executionData = () => {
    let d = [];
    this.state.chart_data.forEach((v)=>{
      d.push(v.executions);
    });

    return d;
  }

  chartLabels = () => {
    let d = [];
    this.state.chart_data.forEach((v)=>{
      d.push(v.date);
    });

    return d;
  }

  commissionData = () => {
    let d = [];
    this.state.chart_data.forEach((v)=>{
      let val = (parseFloat(v.buy_commission) + parseFloat(v.sell_commission))/10;
      d.push(val);
    });

    return d;
  }

  valueData = () => {
    let d = [];
    this.state.chart_data.forEach((v)=>{
      d.push(v.value);
    });

    return d;
  }

  render() {
    const { classes, historyData } = this.props;
    const { total_commission, total_value, total_executions, total_orders } = this.state;

    return (
      <FusePageCarded
        classes={{
          root: classes.layoutRoot
        }}
        header={<div />}

        leftSidebarContent={
          <WatchList />
        }
        content={
          <div className={classes.content}>
            {!(this.props.selectedCompany) &&
              <Dashboard />
            }
            {(this.props.selectedCompany) &&
            <React.Fragment>
              <Button style={{float:'right'}} onClick={this.closeCompany}><Icon>close</Icon></Button>
              {/*<a style={{float:'right',color:'white', padding:10, borderRadius:4}} className={'inline-block bg-green-dark hover:bg-green-light uppercase hover:text-white'} target="_blank" href={this.state.crmLink}>Open CRM Record</a>*/}
              <Typography variant="display1">{this.props.selectedCompany.name}</Typography>
              <div className={classes.flexBox}>
                <OrdersChart history={historyData}/>
                <OHLC history={historyData}/>
              </div>

              <div className={classNames(classes.flexBox, classes.dataContainer)}>
                <div style={{width: '100%', height: '100%'}}>
                  <div className={classes.flexBox}>
                    <div className={'flex-1'}>
                      <DataTile
                        data={{
                          conversion: {
                            value   : total_executions,
                          },
                        datasets  : [
                          {
                            label: 'Executions',
                            data : this.executionData(),
                          }
                        ],
                        ...this.widgetOptions()}}
                        title="Executions (30 Days)"/>
                    </div>
                    <div className={'flex-1'}>
                      <DataTile
                        data={{
                          conversion: {
                            value   : (this.state.currency) ? this.state.currency.currency_symbol + Util.addThousandCommas(total_commission/10) : '' + Util.addThousandCommas(total_commission/10),
                          },
                          datasets  : [
                            {
                              label: 'Commissions',
                              data : this.commissionData(),
                            }
                          ],
                          ...this.widgetOptions()}}
                        title="Commissions (30 Days)"/>
                    </div>
                    <div className={'flex-1'}>
                      <DataTile
                        data={{
                          conversion: {
                            value   : (this.state.currency) ? this.state.currency.currency_symbol  + Util.addThousandCommas(total_value): '' + Util.addThousandCommas(total_value),
                          },
                          datasets  : [
                            {
                              label: 'Conversion',
                              data : [221, 428, 492, 471, 413]
                            }
                          ],
                          ...this.state.widget_options}}
                        title="Completed Order Value (30 Days)"/>
                    </div>
                    <div className={'flex-1'}>
                      <DataTile
                        data={{
                          conversion: {
                            value   : total_orders,
                          },
                          datasets  : [
                            {
                              label: 'Conversion',
                              data : [221, 428, 492, 471, 413]
                            }
                          ],
                          ...this.state.widget_options}}
                        title="Open Orders" showChart={false}/>
                      </div>
                  </div>
                </div>
              </div>
              <div className={classNames('flex')}>
                <div className={classNames(classes.dataContainer)}  style={{width:'40%'}}>
                  <div className={classNames(classes.depth)}>
                  <div className="px-4 py-2 m-2 w-full my-8">
                    <Tabs
                      value={this.state.tab3}
                      indicatorColor="primary"
                      textColor="secondary"
                      onChange={this.handleTabChangeSecondary}
                    >
                      <Tab classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                           label="Market Depth"
                           value={0}
                      />
                    </Tabs>
                  </div>
                  {this.state.tab3 === 0 &&
                  <div className="flex-col flex" style={{height:'100%'}}>
                    <div className={classNames(classes.flexBox, classes.margin20, classes.marginX5)}
                         style={{flex: 1, alignItems: 'flex-start'}}>
                      <div className={classNames(classes.whiteScrollHandler)}
                           style={{width:'50%',height: '100%', display: 'flex', flexDirection: 'column'}}>

                        <div className={classNames(classes.tableHeader, classes.flexBox, 'center')}>
                          <Span className={'bold'}>BIDS</Span>
                        </div>
                        <div className={classNames(classes.tableRow, ' flex center')}
                             style={{background: 'white'}}>
                          <div className={'flex-1'} style={{textAlign:'center'}}>#</div>
                          <div className={'flex-1'} style={{textAlign:'center'}}>QTY</div>
                          <div className={'flex-1'} style={{textAlign:'center'}}>T</div>
                          <div className={'flex-1'} style={{textAlign:'center'}}>$</div>
                        </div>
                        {((typeof this.state.consOrders['buy'] !== 'undefined') && this.state.consOrders['buy'].length > 0) &&
                        <div style={{flex: 1, overflowY: 'overlay'}} className={classes.whiteScrollHandler}>
                          {this.state.consOrders['buy'].map((order, index) =>
                            <div className={classNames(classes.flexBox, classes.tableRow, 'center')} key={index}>
                              <Span width={25}>{Util.addThousandCommas(order.count,'0') || 0}</Span>
                              <Span width={25}>{Util.addThousandCommas(order.qty)}</Span>
                              <Span width={25}>{order._type === 1 ? 'P' : 'F'}</Span>
                              <Span width={25}>${Util.addThousandCommas(order._price, '0, 0.00')}</Span>
                            </div>
                          )}
                        </div>
                        }
                      </div>
                      <div className={classNames(classes.whiteScrollHandler)}
                           style={{width: '47%', height: '100%', display: 'flex', flexDirection: 'column'}}>
                        <div className={classNames(classes.tableHeader, classes.flexBox, 'center')}>
                          <Span className={'bold'}>OFFERS</Span>
                        </div>
                        <div className={classNames(classes.flexBox, classes.tableRow, 'center')}
                             style={{background: 'white'}}>
                          <Span width={25}>$</Span>
                          <Span width={25}>T</Span>
                          <Span width={25}>QTY</Span>
                          <Span width={25}>#</Span>
                        </div>

                        {((typeof this.state.consOrders['buy'] !== 'undefined') && this.state.consOrders['sell'].length > 0) &&
                        <div style={{flex: 1}} className={classes.whiteScrollHandler}>
                          {this.state.consOrders['sell'].map((order, id) =>
                            <div key={id} className={classNames(classes.flexBox, classes.tableRow, 'center')}>
                              <Span width={25}>${Util.addThousandCommas(order._price, '0, 0.00')}</Span>
                              <Span width={25}>{order._type}</Span>
                              <Span width={25}>{Util.addThousandCommas(order.qty)}</Span>
                              <Span width={25}>{Util.addThousandCommas(order.count,'0') || 0}</Span>
                            </div>
                          )}
                        </div>
                        }
                      </div>
                    </div>
                  </div>

                  }
                  </div>
                </div>
                <div style={{width: '65%'}} className={classes.dataContainer}>
                  <OrdersList selectedCompany={this.props.selectedCompany}/>
                </div>
              </div>
            </React.Fragment>
            }
            </div>
        }
      />
    )
  }
}

const mapStateToProps = state => ({
  selectedCompany: companySelector(state),
  historyData: state.company.history,
});

const mapDispatchToProps = {
  selectCompany: fetchCompanyHistory,
  setCompaniesInfo,
};

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(withRouter(CompanyView)));



// WEBPACK FOOTER //
// ./src/main/content/company/Company.js